window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoBonusCodeRepo = function () {
    var post = function (codeId) {
        var url = 'api/casinobonuscode?bonusCode=' + codeId;
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
        }).then(function (response) {
            return response.json();
        })
        .catch(casino.repos.base.handleNetworkException);
    };
    return {
        post: post
    }

}();